var _defs, _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _g, _rect7, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "dropShadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 3,
    floodColor: "#000000",
    floodOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boxGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b82f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563eb"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 95,
    rx: 35,
    ry: 4,
    fill: "#000000",
    opacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 65,
    width: 8,
    height: 32,
    fill: "#64748b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 65,
    width: 8,
    height: 32,
    fill: "#94a3b8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 55,
    height: 35,
    rx: 4,
    fill: "url(#boxGrad)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 32,
    width: 51,
    height: 3,
    rx: 1,
    fill: "#93c5fd",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 34,
    width: 10,
    height: 27,
    rx: 2,
    fill: "#0f172a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 62 34 L 72 34 L 72 36 L 62 36 Z",
    fill: "#1e3a8a"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 65,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#1e3a8a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 69,
    width: 10,
    height: 27,
    rx: 2,
    fill: "#2563eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 71,
    width: 6,
    height: 23,
    rx: 1,
    fill: "none",
    stroke: "#1d4ed8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 90,
    width: 4,
    height: 2,
    fill: "#94a3b8"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 55,
    width: 22,
    height: 5,
    rx: 2.5,
    fill: "#ef4444"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 57.5,
    r: 4,
    fill: "#b91c1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty_box.16f5384d2dc96ee2ac38027c8021049d.svg";
export { ForwardRef as ReactComponent };